import { httpClient } from './httpClient';

const base = '/api/documentos-catalogo';

// Lectura: cualquier usuario autenticado (DocumentosPanel la necesita para
// pintar la lista de tipos, incluye inactivos para no perder documentos
// históricos de tipos ya retirados).
export const listarDocumentosCatalogo = () => httpClient.get(base);

// Escritura: requiere permiso "configuracion" (ver Configuración > Documentos).
export const crearDocumentoCatalogo = (payload) => httpClient.post(base, payload);
export const actualizarDocumentoCatalogo = (id, payload) => httpClient.put(`${base}/${id}`, payload);
